import './styles/ButtonLoader.scss';

export function ButtonLoader() {
    return (
        <div className="palette-button__loader">
            {[...Array(5).keys()].map(key => (
                <div
                    key={key}
                    className="palette-button__loader__out"
                >
                    <div className="palette-button__loader__in" />
                </div>
            ))}
        </div>
    );
}

export default ButtonLoader;
